<template>
  <div>
    <vue-headful title="Credimóvil | Aviso de privacidad" />
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area banner_area_5">
      <div class="container">
        <h6></h6>
        <h2>Aviso legal sobre el chatbot</h2>
        <ol class="breadcrumb">
          <li></li>
          <li></li>
        </ol>
      </div>
    </section>
    <!-- Banner Area -->

    <!-- Achieve your financial -->
    <section class="achieve_financial_area afa_2">
      <div class="container">
        <div class="aviso-de-privacidad-text text-justify">

          <div class=" text-center">

            <h3 class="ft13Black">Aviso legal sobre el chatbot</h3>
            <h4 class="ft13Black">“GPI, AUTO COMERCIAL, S.A.P.I. DE C.V.”</h4>
          </div>
          <br>

          <p class="pb-3">
            Recuerda que Chatbot es creado por inteligencia artificial:
            Es posible que la información que se te proporcione no sea precisa, por lo que debes corroborarla con tu
            asesor comercial.
            El Bot no cotiza ni realiza operaciones de tipo alguno, solo pretende perfilar y ayudar a resolver a dudas.
            <br> <br>
            <strong>
              Al utilizar el chatbot liberas de cualquier responsabilidad a GPI AUTO COMERCIAL, S.A.P.I. DE C.V. por
              cualquier daño y/o perjuicio que pudieras sufrir derivado o relacionado con el uso del mismo, sus
              respuestas
              y/o su ausencia de respuesta. Las respuestas proporcionadas por el Chatbot de ninguna forma tienen
              carácter
              vinculatorio para GPI AUTO COMERCIAL, S.A.P.I. de C.V. ni se considerarán como ofertas vinculantes y/o
              aceptaciones de tipo alguno.
            </strong>
          </p>


        </div>
      </div>
    </section>
    <!-- Achieve your financial -->
  </div>
</template>

<script>
export default {
  name: 'PrivacyNotice'
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/PrivacyChatbot.vue